import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.number.index')
  .add('pbx.breadcrumb.number.index', { name: 'pbx.number.index' });

export const pbx_numbers_breadcrumbs = [index];
